module.exports = __webpack_public_path__ + "img/logo-4.5c010c85.png";